import { render, staticRenderFns } from "./CalendarEventSendNews.vue?vue&type=template&id=4116281f"
import script from "./CalendarEventSendNews.vue?vue&type=script&lang=js"
export * from "./CalendarEventSendNews.vue?vue&type=script&lang=js"
import style0 from "./CalendarEventSendNews.vue?vue&type=style&index=0&id=4116281f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports